__turbopack_context__.v({
  "card": "DBrw0q_card",
  "footer": "DBrw0q_footer",
  "header": "DBrw0q_header",
  "icon": "DBrw0q_icon",
  "list": "DBrw0q_list",
  "placeholder": "DBrw0q_placeholder",
  "subheadline": "DBrw0q_subheadline",
  "switch-button": "DBrw0q_switch-button",
  "switch-button-active": "DBrw0q_switch-button-active",
  "switch-input": "DBrw0q_switch-input",
  "switch-input-right-active": "DBrw0q_switch-input-right-active",
  "switch-wrapper": "DBrw0q_switch-wrapper",
});
